export const DICE_TYPES = [4, 6, 8, 10, 12, 20, 100] as const;
export type DiceType = (typeof DICE_TYPES)[number];

export interface DieResult {
  type: DiceType;
  value: number;
  parts?: readonly number[];
}

export interface RollResult {
  dice: readonly DieResult[];
  total: number;
}

export interface DiceEngine {
  initialize(container: string): Promise<void>;
  roll(selection: readonly DiceType[]): Promise<RollResult>;
  clear(): void;
  destroy(): void;
}
